import { useEffect, useState } from "react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

export default function HomeBanner() {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  // 🔥 Fetch banners from API
  const fetchBanners = async () => {
    try {
      const res = await api({
        url: SummaryApi.getAllBanners.url,
        method: SummaryApi.getAllBanners.method,
      });

      const data = res.data?.data || [];

      // ✅ only active banners
      const active = data.filter((b) => b.status);

      setBanners(active);

    } catch (err) {
      console.error("Banner fetch error:", err);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // 🔥 Auto slider
  useEffect(() => {
    if (banners.length === 0) return;

    const slider = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 3000); // better UX (3 sec)

    return () => clearInterval(slider);
  }, [banners]);

  if (banners.length === 0) {
    return (
      <div className="w-full h-[calc(101vh-80px)] flex items-center justify-center">
        No active banners
      </div>
    );
  }

  return (
    // <div className="w-full h-[450px] md:h-[calc(101vh-80px)] relative overflow-hidden mb-12">
    //   {banners.map((banner, index) => (
    //     <img
    //       key={banner._id}
    //       src={banner.image.url}
    //       alt={banner.title}
    //       className={`absolute w-full h-full object-fill transition-opacity duration-1000 ${
    //         index === current ? "opacity-100" : "opacity-0"
    //       }`}
    //     />
    //   ))}
    // </div>
    <div className="w-full relative overflow-hidden mb-12">
    {/* Aspect Ratio Container */}
    <div className="relative w-full aspect-[16/9] md:aspect-[16/9] lg:aspect-[16/9] xl:h-[calc(100vh-80px)]">
      {banners.map((banner, index) => (
        <img
          key={banner._id}
          src={banner.image.url}
          alt={banner.title}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
    </div>
  </div>
  );
}